<template>
  <LoadingState
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex
      v-if="method"
      xs12
      ma-3
    >
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <translatable
            :language="language"
            v-model="method"
            field-name="name"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('name')"
                :label="$t('Name')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
          <translatable
            :language="language"
            v-model="method"
            field-name="description"
          >
            <template
              #default="{ fieldValue, fieldMutator }"
            >
              <v-text-field
                v-model="fieldValue"
                :error-messages="method.displayErrors('description')"
                :label="$t('Description')"
                outline
                @change="fieldMutator(fieldValue)"
              />
            </template>
          </translatable>
        </template>
      </translations-tabs>
      <v-text-field
        v-model="method.clientId"
        :error-messages="method.displayErrors('clientId')"
        :label="$t('Client ID')"
        outline
      />
      <v-text-field
        v-model="method.secret"
        :error-messages="method.displayErrors('secret')"
        :label="$t('Secret Key')"
        outline
      />
      <v-layout align-start>
        <v-flex>
          <v-switch
            v-model="method.testMode"
            :label="$t('Test mode')"
          />
        </v-flex>
        <v-flex>
          <v-text-field
            v-model.number="method.order"
            :error-messages="method.displayErrors('order')"
            :label="$t('Order')"
            type="number"
            outline
          />
        </v-flex>
      </v-layout>
      <application-select v-model="method.application"/>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'PaymentProviderPaypal',
  components: { Translatable, TranslationsTabs, ImageUpload, ApplicationSelect, LoadingState },
  props: {
    method: {
      type: Object,
      default: () => {
      }
    }
  },

  data () {
    return {
      schema: {
        'code': 'paypal',
        'name': '',
        'enabled': true,
        'application': null,
        'testMode': true,
        'clientId': '',
        'secret': '',
        'description': '',
        'image': '',
        'order': ''
      },
      sensitiveErrorFields: {
        clientId: 'client id'
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema,
      sensitiveErrorFields: this.sensitiveErrorFields
    })
  }
}
</script>
